export enum Roles {
    SHAREHOLDER = 'SH',
    BENEFICIAL_OWNER = 'BO',
    PARTNER = 'PR',
    DESIGNATED_MEMBER = 'DM',
    MEMBER = 'MB',
    FOUNDING_MEMBER = 'FM',
    ORDINARY_MEMBER = 'OM',
    GENERAL_PARTNER = 'GP',
    LIMITED_PARTNER = 'LP',
    APPLICANT = 'AP',
    DIRECTOR = 'DP',
    CEO = 'CEO',
    SECRETARY = 'SC',
    AUTHORISED_SIGNATORY = 'AS',
    PERSON_AUTHORISED = 'PA',
    MONEY_LAUNDERING_REPORTING_OFFICER = 'MLRO',
    PARENT_COMPANY = 'PC',
    FOUNDER = 'FO',
    MEMBER_OF_THE_COUNCIL = 'MC',
    GUARDIAN = 'GU',
    QUALIFIED_RECIPIENT = 'QR',
    DEFAULT_RECIPIENT = 'DE',
    PAYR = 'PAYR',
    PCNT = 'PCNT',
    RCPT = 'RCPT',
    DPH = 'DPH',
    RP = 'RP'
}

export const ROLES_MESSAGE_MAP: Map<string, string> = new Map([
    [Roles.SHAREHOLDER, 'Shareholder'],
    [Roles.BENEFICIAL_OWNER, 'Beneficial Owner'],
    [Roles.PARTNER, 'Partner'],
    [Roles.DESIGNATED_MEMBER, 'Designated Member'],
    [Roles.MEMBER, 'Member'],
    [Roles.ORDINARY_MEMBER, 'Ordinary Member'],
    [Roles.GENERAL_PARTNER, 'General Partner'],
    [Roles.LIMITED_PARTNER, 'Limited Partner'],
    [Roles.APPLICANT, 'Applicant'],
    [Roles.DIRECTOR, 'Director'],
    [Roles.SECRETARY, 'Secretary'],
    [Roles.AUTHORISED_SIGNATORY, 'Authorised Signatory'],
    [Roles.PERSON_AUTHORISED, 'Person Authorised to accept services'],
    [Roles.MONEY_LAUNDERING_REPORTING_OFFICER, 'Money Laundering Reporting Officer'],
    [Roles.PARENT_COMPANY, 'Parent Company'],
    // [Roles.PRINCIPAL_CONTACT, 'Principal Contact'],
    // [Roles.BACKUP_CONTACT, 'Backup Contact'],
    // [Roles.KEY_OFFICER_STAFF, 'Key Officer Staff'],
    [Roles.FOUNDER, 'Founder'],
    [Roles.FOUNDING_MEMBER, 'Founding Member'],
    [Roles.MEMBER_OF_THE_COUNCIL, 'Member Of The Council'],
    [Roles.CEO, 'CEO'],
    // [Roles.ULTIMATE_BENEFICIAL_OWNER, 'Ultimate Benefecial Owner'],
    [Roles.DEFAULT_RECIPIENT, 'Default Recipient'],
    [Roles.QUALIFIED_RECIPIENT, 'Qualified Recipient'],
    [Roles.GUARDIAN, 'Guardian'],
    [Roles.DPH, 'Director of the Head Company'],
    [Roles.RP, 'Partner of Head Office'],
    // [Roles.JOINT_HOLDER, 'Joint Holder'],
    // [Roles.SENIOR_EXECUTIVE_OFFICER, 'Senior Executive Officer'],
    // [Roles.SENIOR_MANAGER, 'Senior Manager'],
    // [Roles.FUND_MANAGER, 'Fund Manager'],
    // [Roles.FINANCE_OFFICER, 'Finance Officer'],
    // [Roles.COMPLIANCE_OFFICER, 'Compliance Officer'],
    // [Roles.ADDITIONAL_APPROVED_OR_DESIGNATED_INDIVIDUAL, 'Additional Approved or Designated Individual'],
    // [Roles.CHIEF_INFORMATION_TECHNOLOGY_OFFICER, 'Chief Information Technology Officer'],
  ]);